//
//
//
//
//
//
//
//
//
//
//
//
//

import portal from '~/net/portal';
import Courier from '~/components/Courier';
import CzHead from '~/components/cz/CzHead.vue';
import CzHead2 from '~/components/cz/CzHead2.vue';
import CzFooter from '~/components/cz/CzFooter.vue';
import Breadcrumbs from '~/components/cz/Breadcrumbs.vue';
import { czHomePath } from '~/constant/cz';
export default {
  head() {
    return {
      title: '江苏省技术产权交易市场-专利技术转让-专利交易发布-知识产权申请平台',
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: '专利转让,技术转让,专利交易,知识产权,知识产权申请,江苏省技术产权交易市场',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '江苏省技术产权交易市场平台，专注专利转让、技术转让、专利交易、知识产权、知识产权申请，包括发明技术成果、实用新型专利、知识产权服务、电子信息、生物与新医药、航空航天、新材料、高技术服务、新能源与节能资源与环境、先进制造与自动化等服务。',
        },
      ],
    };
  },
  middleware: 'appData',
  components: {
    Courier,
    CzHead,
    CzFooter,
    CzHead2,
    Breadcrumbs,
  },
  data() {
    return {
      showRightWidow: true,
      navigationType: '',
    };
  },
  computed: {
    headerType() {
      const path = this.$route.path;
      const pathArr = path.split('/');
      return pathArr[pathArr.length - 1].includes('changzhou') ? 'CzHead' : 'CzHead2';
    },
    footerType() {
      const path = this.$route.path;
      const pathArr = path.split('/');
      return pathArr[pathArr.length - 1].includes('changzhou') ? '' : 'CzFooter';
    },
    breadcrumbs() {
      const path = this.$route.path;
      return path === czHomePath || path === czHomePath + '/' ? '' : 'Breadcrumbs';
    },
  },
  created() {
    this.queryHis();
  },
  methods: {
    async queryHis() {
      const strCookie = document.cookie;
      const cookies = strCookie.split(' ');
      let touristId = '';
      cookies.map((str) => {
        if (str.includes('NW_TOURIST_ID')) {
          const tempArr = str.split('=');
          touristId = tempArr[1];

          if (touristId.indexOf(';') > 0) {
            touristId = touristId.substring(0, touristId.length - 1);
          }
          localStorage.setItem('TOURIST_ID', touristId);
        }
      });

      const { code, data } = await portal.selectHomePageActivityId({
        body: {
          touristId,
        },
      });

      if (code == '0000') {
      }
    },
  },
};
